import { getRoleId } from "./ids";
import { fetchFromSubgraph } from "./subgraph";
import { Clearance, ExecutionOptions, } from "./types";
export const ROLE_FIELDS = `
    key
    members {
      member {
        address
      }
    }
    targets {
      address
      clearance
      executionOptions
      functions {
        selector
        executionOptions
        wildcarded
        condition {
          id
          json
        }
      }
    }
    annotations {
      uri
      schema
    }
    lastUpdate
`.trim();
const ROLE_QUERY = `
query Role($id: ID!, $blockNumber: Int) {
  role(id: $id, blockNumber: $blockNumber) {
    ${ROLE_FIELDS}
  }
}
`.trim();
export const fetchRole = async ({ chainId, address, roleKey, blockNumber }, options) => {
    const { role } = await fetchFromSubgraph({
        query: ROLE_QUERY,
        variables: {
            id: getRoleId(chainId, address, roleKey),
            blockNumber,
        },
        operationName: "Role",
    }, options);
    if (!role) {
        return null;
    }
    return mapGraphQl(role);
};
export const mapGraphQl = (role) => ({
    ...role,
    members: role.members.map((assignment) => assignment.member.address),
    targets: role.targets.map((target) => ({
        address: target.address,
        clearance: Clearance[target.clearance],
        executionOptions: ExecutionOptions[target.executionOptions],
        functions: target.functions.map((func) => ({
            selector: func.selector,
            executionOptions: ExecutionOptions[func.executionOptions],
            wildcarded: func.wildcarded,
            condition: func.condition && JSON.parse(func.condition.json),
        })),
    })),
});
